import { useStripe } from '@stripe/react-stripe-js';
import { CanMakePaymentResult, PaymentRequest } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';

const defaultState = {
  applePay: false,
  googlePay: false,
  link: false,
};

export let paymentRequest: PaymentRequest;

export function useAvailableWallets() {
  const [availableWallets, setAvailableWallets] = useState<CanMakePaymentResult>(defaultState);
  const stripe = useStripe();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    paymentRequest = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        amount: 0,
        label: 'Initial Label',
      },
    });

    paymentRequest.canMakePayment().then(result => {
      if (result) {
        setAvailableWallets(result);
      }
    });
  }, [setAvailableWallets, stripe]);

  return {
    availableWallets,
  };
}
